import { render, staticRenderFns } from "./ListAside.vue?vue&type=template&id=5b32461c&scoped=true&"
import script from "./ListAside.vue?vue&type=script&lang=js&"
export * from "./ListAside.vue?vue&type=script&lang=js&"
import style0 from "./ListAside.vue?vue&type=style&index=0&id=5b32461c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b32461c",
  null
  
)

export default component.exports